import { billingPortal } from "./billingPortal";
import { checkoutSession } from "./checkoutSession";
import { invoice } from "./invoice";

export const accountPaymentProcessors = {
  billingPortal,
  checkoutSession,
  invoice,
};
